import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import parse from 'html-react-parser'
import styles from './Confirmation.module.scss'

const Confirmation: FC = () => {
  const { t } = useTranslation('generator')

  return (
    <h4 className={styles.confirmation}>
      {parse(
        t(
          'confirmation',
          'Bedankt! <span>We hebben jouw gegevens goed ontvangen. We nemen zo snel mogelijk contact met je op. Dit kan tot 5 werkdagen duren.</span>'
        )
      )}
    </h4>
  )
}

export default Confirmation
